import React, { useEffect } from "react";
import Spacer from "../../components/Spacer/Spacer";
import EmailForm from "../../components/EmailForm/EmailForm";

const Contact = () => {
  useEffect(() => {
    document.title = "Contact/StudioMK";
  }, []);

  return (
    <div>
      <Spacer size="medium"></Spacer>
      <EmailForm></EmailForm>
    </div>
  );
};

export default Contact;
